import { PageHeader } from '@/components/PageHeader'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { IndianEnrollForm } from './IndianEnrollForm'
import { InternationalEnrollForm } from './InternationalEnrollForm'
import { Globe, MapPin } from 'lucide-react'

export function EnrollPage() {
  return (
    <div className="space-y-4">
      <PageHeader title="Enroll" subtitle="Create student enrollments for Indian and international students." />
      <Tabs defaultValue="indian" className="w-full">
        <TabsList className="w-full justify-start gap-1 bg-muted p-1">
          <TabsTrigger
            value="indian"
            className="flex items-center gap-1.5 rounded-md px-4 py-2 text-sm data-[state=active]:bg-card data-[state=active]:text-primary data-[state=active]:shadow-sm"
          >
            <MapPin className="size-4" strokeWidth={1.5} />
            Indian Student
          </TabsTrigger>
          <TabsTrigger
            value="international"
            className="flex items-center gap-1.5 rounded-md px-4 py-2 text-sm data-[state=active]:bg-card data-[state=active]:text-primary data-[state=active]:shadow-sm"
          >
            <Globe className="size-4" strokeWidth={1.5} />
            International
          </TabsTrigger>
        </TabsList>
        <TabsContent value="indian" className="mt-4">
          <IndianEnrollForm />
        </TabsContent>
        <TabsContent value="international" className="mt-4">
          <InternationalEnrollForm />
        </TabsContent>
      </Tabs>
    </div>
  )
}
